import type { ReactNode } from 'react';

import { useUsersGetMe } from '@/api/WhisApi/generated/users/users';
import { KeyValueRow } from '@/components/KeyValueRow/KeyValueRow';
import { useAppTranslation } from '@/hooks/useAppTranslation';
import { YStack } from 'tamagui';

export function PersonalInformation(): ReactNode {
  const { t, language } = useAppTranslation();
  const { data: user } = useUsersGetMe();

  const countryName = user?.country?.name?.[language] ?? user?.country?.code;

  return (
    <YStack gap="$true">
      <KeyValueRow
        label={t('profile.personalInformation.fields.lastName')}
        value={user?.lastName}
      />
      <KeyValueRow
        label={t('profile.personalInformation.fields.firstName')}
        value={user?.firstName}
      />
      <KeyValueRow
        label={t('profile.personalInformation.fields.email')}
        value={user?.email}
      />
      <KeyValueRow
        label={t('profile.personalInformation.fields.country')}
        value={countryName}
      />
      <KeyValueRow
        label={t('profile.personalInformation.fields.organization')}
        value={user?.organization}
      />
    </YStack>
  );
}
